export default __webpack_public_path__ + "./image/4a64d0018b0a714eff7522fe39b455de.png";